// extracted by mini-css-extract-plugin
export default {"m":"RGEEKDSse8_pdp","l":"IsBocHBj5X_pdp"};